
export const globalMixin = {
    computed: {
        $mobileBreakpoint() {
            return this.$vuetify.breakpoint.smAndDown
        }
    }
}